import { z } from 'zod'

export const portfolioPositionResponseSchema = z.object({
  instrumentUid: z.string(),
  figi: z.string(),
  ticker: z.string(),
  instrumentName: z.string(),
  instrumentType: z.string(),
  quantity: z.number(),
  lotSize: z.number().int(),
  averagePrice: z.number(),
  currentPrice: z.number(),
  expectedYield: z.number(),
  expectedYieldPercent: z.number(),
  currentValue: z.number(),
  currency: z.string(),
})

export type PortfolioPositionResponseDto = z.infer<typeof portfolioPositionResponseSchema>
